/**
 * Strip HTML tags and decode HTML entities from a string
 * @param {string} html - The HTML string to clean
 * @returns {string} - Clean plain text
 */
export function stripHtmlAndEntities(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  try {
    // First, decode any escaped HTML (like &lt; to <)
    let decoded = html
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');

    // Use DOMParser to parse and extract text content
    const parser = new DOMParser();
    const doc = parser.parseFromString(decoded, 'text/html');

    // Get text content - this automatically strips all HTML tags
    let text = doc.body.textContent || doc.body.innerText || '';

    // Decode remaining HTML entities and clean up whitespace
    text = text
      .replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return text;
  } catch (error) {
    console.error('Error stripping HTML:', error);
    // Fallback: simple regex-based stripping
    return html
      .replace(/<[^>]*>/g, ' ')
      .replace(/&[a-z]+;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}

/**
 * Get a clean, shortened description for sharing
 * @param {string} description - The product description (may contain HTML)
 * @param {number} maxLength - Maximum length of the description
 * @returns {string} - Clean, shortened description
 */
export function getShareDescription(description, maxLength = 200) {
  if (!description) {
    return 'I found this product on SmallSmall!';
  }

  const cleanText = stripHtmlAndEntities(description);

  if (!cleanText || cleanText.length === 0) {
    return 'I found this product on SmallSmall!';
  }

  if (cleanText.length <= maxLength) {
    return cleanText;
  }

  // Truncate at the last complete word before maxLength
  const truncated = cleanText.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');

  if (lastSpace > 0) {
    return truncated.substring(0, lastSpace) + '...';
  }

  // If no space found, just truncate
  return truncated + '...';
}
